
import React from 'react';
import { WeatherCondition } from '@/types/weather';
import WeatherIcon from './WeatherIcon';
import { format } from 'date-fns';
import { it } from 'date-fns/locale';
import { getRandomTemperature } from './WeatherUtils';

interface ForecastDayCardProps {
  date: Date;
  condition: WeatherCondition;
}

const ForecastDayCard: React.FC<ForecastDayCardProps> = ({ date, condition }) => {
  const temperature = getRandomTemperature(condition);
  
  return (
    <div className="bg-black/30 backdrop-blur-sm rounded-lg p-2 flex flex-col items-center">
      <div className="text-xs font-medium mb-1">
        {format(date, 'EEEE d', { locale: it })}
      </div>
      <WeatherIcon condition={condition} size="sm" />
      <div className="text-sm font-bold mt-1">{temperature}°C</div>
    </div>
  );
};

export default ForecastDayCard;
